import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import {
  IconButton,
  Stack,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
  useGetUserApiQuery,
  useRemoveAddressApiMutation,
} from "../../../../../Store/Slices/rtk";
import { notify } from "../../../../../App";
import AddAdressModal from "./AddAdressModal";
import { GradientBorderBox } from "../../../../../Components";
export default function Profile() {
  const theme = useTheme();
  const [openModal, setOpenModal] = useState(false);
  const [removeAddressApi, { isloading }] = useRemoveAddressApiMutation();
  const profile = useGetUserApiQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });
  const user = profile?.data?.data;

  const isMobile = useMediaQuery("(max-width:600px)");
  const spliter = (word, limit) => {
    const nums = word.split(" ").slice(0, limit);
    const add = nums.length >= limit ? "..." : "";
    return nums.join(" ") + add;
  };

  const handleDeleteBtn = async (code) => {
    const removed = await removeAddressApi(code);

    if (removed?.data?.status == "ok") {
      profile?.refetch();
      notify("با موفقیت حذف شد !");
    } else {
      notify("مشکلی در حذف پیش آمد، دوباره تلاش کنید !", "error");
    }
  };
  //  adCode={item?.code}
  //       location={item?.city + " , " + item?.address_line}
  //       postCode={item?.postal_code}
  //       station={item?.name}

  const showItems = user?.address?.map((e, index) => {
    return (
      <Stack
        key={index}
        direction={"row"}
        sx={{ position:"relative", borderRadius: "6px", direction: "rtl" , zIndex:"10" }}
        justifyContent={"space-between"}
      >
        <Stack
          direction={"row"}
          sx={{
            color: theme.palette.primary.main,
            direction: "rtl",
            py: ".7rem",
            gap: "2rem",
            px: "1rem",
          }}
        >
          <Typography sx={{ fontWeight: "bold" }}>{e?.name}</Typography>
          <Typography>
            {isMobile
              ? spliter(e?.address_line, 5)
              : spliter(e?.address_line, 20)}
          </Typography>
        </Stack>
        <IconButton onClick={() => handleDeleteBtn(e?.code)} color="error">
          <DeleteOutlineIcon />
        </IconButton>
        <GradientBorderBox radius=".5rem" />
      </Stack>
    );
  });
  return (
    <>
      <AddAdressModal
        openModal={openModal}
        setOpenModal={setOpenModal}
        username={user?.first_name}
        refetchGet={profile.refetch}
        number={user?.phone}
      />
      <Stack
        sx={{
          color: "white",
          direction: "rtl",
          gap: "0rem",
          width: "100%",
          height: "100%",
        }}
      >
        <Stack
          alignItems={"center"}
          gap={"1rem"}
          sx={{ mb: "2rem" }}
          direction={{ xs: "column", sm: "row" }}
        >
          <Stack sx={{ width: { xs: "90%", sm: "50%" }, gap: ".8rem" }}>
            <Typography sx={{ fontWeight: "bold", fontSize: ".9rem" }}>
              نام کاربری
            </Typography>
            <TextField
              slotProps={{ input: { readOnly: true } }}
              value={user?.first_name || "کاربر نامشخص"}
              size={"small"}
              sx={{
                border: `2px solid ${theme.palette.primary.main}`,
                borderRadius: ".5rem",
                "& .MuiInputBase-input": {
                  color: "white",
                  borderRadius: ".5rem",
                  direction: "rtl",
                },
              }}
            />
          </Stack>
          <Stack sx={{ width: { xs: "90%", sm: "50%" }, gap: ".8rem" }}>
            <Typography sx={{ fontWeight: "bold", fontSize: ".9rem" }}>
              شماره همراه{" "}
            </Typography>
            <TextField
              value={user?.phone || ""}
              slotProps={{ input: { readOnly: true } }}
              size={"small"}
              sx={{
                border: `2px solid ${theme.palette.primary.main}`,
                borderRadius: ".5rem",
                "& .MuiInputBase-input": {
                  color: "white",
                  borderRadius: ".5rem",
                },
              }}
            />
          </Stack>
        </Stack>

        {/* Addresses */}
        <Stack
          direction={"row"}
          sx={{
            width: "100%",
            justifyContent: "space-between",
            gap: "1rem",
            height: "100%",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.3rem",
              color: theme.palette.primary.main,
              fontWeight: "bold",
            }}
          >
            آدرس ها
          </Typography>
          <IconButton onClick={() => setOpenModal(true)}>
            <AddCircleIcon sx={{ color: theme.palette.primary.main }} />
          </IconButton>
        </Stack>
        <Stack
          sx={{
            maxHeight: { xs: "300px", sm: "420px", md: "500px" },
            height: "100%",
            overflow: "auto",
            direction: "ltr",
            py: ".5rem",
            px: ".2rem",
            spacing: "1rem",

            "&::-webkit-scrollbar": {
              width: "8px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#f0f0f0",
              borderRadius: "8px",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#1976d2",
              borderRadius: "8px",
              border: "2px solid #f0f0f0",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              backgroundColor: "#115293",
            },

            scrollbarWidth: "thin",
            scrollbarColor: `${theme.palette.primary.main} ${theme.palette.secondary.main}`,
          }}
          spacing={"1rem"}
        >
          {showItems?.length > 0 ? (
            showItems
          ) : (
            <Stack
              sx={{
                color: theme.palette.primary.main,
                justifyContent: "center",
                fontSize: "1.2rem",
                alignItems: "center",
                height: "400px",
                width: "100%",
              }}
            >
              هنوز آدرسی ثبت نشده است
            </Stack>
          )}
        </Stack>
      </Stack>
    </>
  );
}
